module.exports = __webpack_public_path__ + "img/Moments.a3947102.svg";